import { Component, input, model } from '@angular/core';
import { OtapUpgradeTaskDTO } from '@app/shared/models/otap-upgrade-task.interface';
import { OtapUpgradeDTO } from '@app/shared/models/otap.upgrade.interface';

import { JobTasksSummaryComponent } from '../job-tasks-summary/job-tasks-summary.component';

@Component({
  selector: 'app-job-tasks-list',
  templateUrl: './job-tasks-list.component.html',
  styleUrls: ['./job-tasks-list.component.scss'],
  imports: [JobTasksSummaryComponent]
})
export class JobTasksListComponent {
  readonly tasks = input<OtapUpgradeTaskDTO[]>([]);
  readonly job = input.required<OtapUpgradeDTO>();
  readonly jobStartEnabled = model.required<boolean>();
}
